// DigiDoot site content data
import {
  Megaphone, Rocket, Search, Target, LineChart, Users, Mic2, Video,
  Palette, PenTool, Film, Sparkles, Globe, Magnet, MessageSquare,
} from 'lucide-react';

export const LOGO_URL = '/logo.png';

export const CONTACT = {
  email: 'digidoot42@gmail.com',
  phone: '+91 83108 36675',
  phoneRaw: '918310836675',
  whatsapp: 'https://wa.me/918310836675',
  address: 'Bengaluru South, India',
  socials: {
    instagram: 'https://www.instagram.com/digidoot_solutions',
    linkedin: 'https://www.linkedin.com/company/digidoot',
    youtube: 'https://www.youtube.com/@digidoot',
    facebook: 'https://www.facebook.com/digidoot',
  },
};

export const SERVICES = [
  { icon: Megaphone, title: 'Social Media Marketing', desc: 'Strategy-first content that turns followers into fans and fans into customers.' },
  { icon: Rocket, title: 'Performance Marketing', desc: 'Full-funnel paid media engineered around ROAS, CAC and LTV — not vanity metrics.' },
  { icon: Search, title: 'SEO', desc: 'Technical, on-page and content SEO that compounds into predictable organic growth.' },
  { icon: Target, title: 'Google Ads', desc: 'Search, Performance Max and YouTube campaigns tuned for high-intent buyers.' },
  { icon: LineChart, title: 'Meta Ads', desc: 'Creative-led Meta campaigns with rigorous testing, tracking and iteration.' },
  { icon: Users, title: 'Influencer Marketing', desc: 'Curated creator collaborations that feel native, not scripted.' },
  { icon: Mic2, title: 'Podcast Production', desc: 'End-to-end podcast production — from concept and scripting to distribution.' },
  { icon: Video, title: 'Podcast Shoots', desc: 'Cinematic multi-camera podcast shoots in editorial-grade sets.' },
  { icon: Palette, title: 'Branding', desc: 'Identity systems, tone of voice and design languages built to last a decade.' },
  { icon: PenTool, title: 'Content Creation', desc: 'Editorial, reels, carousels and long-form written for humans, tuned for algorithms.' },
  { icon: Film, title: 'Video Production', desc: 'DVCs, brand films, product shoots and reels — story-led, beautifully crafted.' },
  { icon: Sparkles, title: 'Creative Strategy', desc: 'Big-idea thinking that unifies brand, campaign and content into one story.' },
  { icon: Globe, title: 'Website Development', desc: 'Fast, elegant websites built to convert — from landing pages to full platforms.' },
  { icon: Magnet, title: 'Lead Generation', desc: 'Predictable lead pipelines powered by content, ads, funnels and automation.' },
  { icon: MessageSquare, title: 'Marketing Consultation', desc: 'Fractional strategist for founders — clarity, direction and quarterly plans.' },
];

export const WHY_CHOOSE = [
  { title: 'ROI-focused campaigns', desc: 'Every rupee tracked. Every campaign accountable to real business outcomes.' },
  { title: 'Experienced creative team', desc: 'Strategists, designers, editors and media buyers under one studio roof.' },
  { title: 'Transparent reporting', desc: 'Weekly dashboards, monthly reviews and quarterly business reviews — always.' },
  { title: 'End-to-end marketing', desc: 'From brand identity to paid ads to podcasts — one accountable partner.' },
  { title: 'Customized strategy', desc: 'No templates. Every plan built from your audience, product and market.' },
  { title: 'Fast execution', desc: 'Small pods, tight loops. Ideas ship in days, not months.' },
  { title: 'Creative storytelling', desc: 'We lead with story. Because performance without narrative fades.' },
];

export const PROCESS = [
  { step: '01', title: 'Discovery', desc: 'Immersion into your brand, audience and business goals.' },
  { step: '02', title: 'Strategy', desc: 'Insight-led strategy across brand, content and paid media.' },
  { step: '03', title: 'Creation', desc: 'Cinematic content, campaigns and creative built to convert.' },
  { step: '04', title: 'Launch', desc: 'Cross-channel go-to-market with airtight tracking.' },
  { step: '05', title: 'Optimization', desc: 'Test, learn, iterate — weekly performance loops.' },
  { step: '06', title: 'Growth', desc: 'Compounding results. Scale what works, kill what doesn\'t.' },
];




export const CLIENTS = [
  {
    name: 'City Municipal Council, Ramanagara',
    industry: 'Government',
    featured: true,
    role: 'Official Marketing Partner',
    badge: 'Official Marketing Partner',
    duration: '2022 – Present',
    logoUrl: 'https://customer-assets.emergentagent.com/job_brand-storytelling-8/artifacts/7wggaazs_IMG_5984.PNG',
    services: ['Public Communication', 'Social Media Management', 'Digital Awareness Campaigns', 'Creative Design', 'Citizen Engagement'],
    desc: 'Our flagship partnership. DigiDoot serves as the Official Marketing Partner — strengthening public communication, citizen engagement and digital outreach through strategic campaigns and creative content.',
  },
  {
    name: 'Buddy Loan',
    industry: 'FinTech',
    role: 'Creative Partner',
    badge: 'Creative Partner',
    duration: '2022 – 2024',
    logoUrl: 'https://icon.horse/icon/buddyloan.com',
    services: ['Creative Design', 'Campaign Creatives', 'Social Media Assets', 'Digital Marketing Support'],
    desc: 'A leading loan aggregation platform in India. Delivered high-quality creative assets, campaign visuals and digital content that supported growth and customer engagement.',
  },
  {
    name: 'RummyCircle',
    industry: 'Gaming',
    duration: '2021 – 2025',
    logoUrl: 'https://icon.horse/icon/rummycircle.com',
    services: ['Creative Campaigns', 'Digital Marketing Assets', 'Promotional Creatives'],
    desc: 'Creative marketing projects for one of India’s largest online gaming brands — producing engaging digital content and campaign creatives across four years of partnership.',
  },
  {
    name: '11Circle',
    industry: 'Gaming',
    duration: '2022 – 2023',
    services: ['Campaign Creatives', 'Social Media Design', 'Performance Marketing Support'],
    desc: 'Campaign creatives and performance marketing support — impactful visuals and digital content aligned with the brand’s objectives.',
  },
  {
    name: 'Jupiter Money',
    industry: 'FinTech',
    badge: 'Performance Partner',
    duration: '2025 – 2026',
    logoUrl: 'https://customer-assets.emergentagent.com/job_brand-storytelling-8/artifacts/2mcpzjr1_images-2.png',
    services: ['Creative Design', 'Branding Support', 'Digital Campaigns'],
    desc: 'Performance-linked partnership driving new customer acquisition on cost-per-sale and cost-per-credit-card-dispatch models — creative, media buying and funnel optimisation.',
  },
  {
    name: 'Bharath Kempanna Multispeciality Hospital',
    industry: 'Healthcare',
    duration: '2024 – Present',
    logoUrl: 'https://customer-assets.emergentagent.com/job_brand-storytelling-8/artifacts/crvnfu9t_739F61E0-9336-4058-9E1E-D7A66370749B.jpg',
    services: ['Branding', 'Social Media Marketing', 'Content Creation', 'Digital Marketing'],
    desc: 'Full-service branding and digital marketing partnership — building trust and connecting the hospital with the local community.',
  },
  {
    name: 'TrustMed Multispeciality Hospital',
    industry: 'Healthcare',
    duration: '2024 – Present',
    logoUrl: 'https://customer-assets.emergentagent.com/job_brand-storytelling-8/artifacts/jgn2ibv0_IMG_2837.JPG',
    services: ['Branding', 'Social Media Management', 'Performance Marketing', 'Patient Awareness Campaigns'],
    desc: 'End-to-end branding, digital marketing and patient awareness — enhancing the hospital’s online presence and outreach.',
  },
  {
    name: 'Dr. Wombholic',
    industry: 'Healthcare',
    duration: '2024 – Present',
    logoUrl: 'https://customer-assets.emergentagent.com/job_brand-storytelling-8/artifacts/dt4pfzjt_IMG_7912%203.JPG',
    services: ['Branding', 'Content Strategy', 'Social Media Marketing', 'Creative Design'],
    desc: 'Building a strong, recognisable women’s healthcare identity through content strategy, branding and social media marketing.',
  },
];

export const ACHIEVEMENTS = [
  { value: 50, suffix: '+', label: 'Brands worked with' },
  { value: 480, suffix: '+', label: 'Campaigns delivered' },
  { value: 90, suffix: 'M+', label: 'Social reach generated' },
  { value: 35, suffix: 'K+', label: 'Leads generated' },
  { value: 98, suffix: '%', label: 'Client retention' },
];

export const TESTIMONIALS = [
  {
    quote: 'DigiDoot didn\u2019t just run our campaigns \u2014 they rebuilt how we think about our brand. Our ROAS tripled in six months and CAC dropped by 38%.',
    name: 'Priya Sharma',
    role: 'Marketing Manager, Fintech Brand',
    rating: 5,
    avatar: 'https://api.dicebear.com/9.x/initials/svg?seed=Priya%20Sharma&backgroundColor=8C5638&textColor=F5EFE6&fontWeight=600&fontSize=42',
  },
  {
    quote: 'Chitra and the team feel like an extension of our leadership. Sharp strategy, gorgeous creative, obsessive tracking \u2014 rare to find all three under one roof.',
    name: 'Arjun Nair',
    role: 'CEO, Healthcare Brand',
    rating: 5,
    avatar: 'https://api.dicebear.com/9.x/initials/svg?seed=Arjun%20Nair&backgroundColor=5C1F2A&textColor=F5EFE6&fontWeight=600&fontSize=42',
  },
  {
    quote: 'The campaign work they produced became our #1 lead source in Q3. Cinematic quality with real business impact.',
    name: 'Neha Reddy',
    role: 'Brand Manager, Consumer Brand',
    rating: 5,
    avatar: 'https://api.dicebear.com/9.x/initials/svg?seed=Neha%20Reddy&backgroundColor=D4AF37&textColor=3B2419&fontWeight=700&fontSize=42',
  },
  {
    quote: 'Best marketing partner we\u2019ve worked with. Honest, fast and genuinely creative. They over-deliver every single month.',
    name: 'Rahul Verma',
    role: 'Founder, D2C Startup',
    rating: 5,
    avatar: 'https://api.dicebear.com/9.x/initials/svg?seed=Rahul%20Verma&backgroundColor=4A2E1F&textColor=F5EFE6&fontWeight=600&fontSize=42',
  },
  {
    quote: 'For a government body, communication needs to be both credible and modern. DigiDoot nailed that balance. Citizen engagement is at an all-time high.',
    name: 'Suresh Gowda',
    role: 'Communications Lead, Municipal Body',
    rating: 5,
    avatar: 'https://api.dicebear.com/9.x/initials/svg?seed=Suresh%20Gowda&backgroundColor=8C5638&textColor=F5EFE6&fontWeight=600&fontSize=42',
  },
  {
    quote: 'Their performance team truly understands the CPA game. Every rupee is tracked back to a conversion. Refreshingly accountable.',
    name: 'Ananya Iyer',
    role: 'Growth Manager, FinTech Brand',
    rating: 5,
    avatar: 'https://api.dicebear.com/9.x/initials/svg?seed=Ananya%20Iyer&backgroundColor=D4AF37&textColor=3B2419&fontWeight=700&fontSize=42',
  },
];

export const FAQS = [
  { q: 'What services do you provide?', a: 'We offer full-stack digital marketing — social media, performance marketing (Google & Meta ads), SEO, branding, content and video production, podcast production, website development and marketing consulting.' },
  { q: 'How long does SEO take to show results?', a: 'Meaningful SEO results typically show between 3–6 months, with compounding growth after that. We share transparent monthly reports on rankings, traffic and conversions from day one.' },
  { q: 'Do you handle Meta and Google Ads?', a: 'Yes. Paid media is one of our core practices. We handle full-funnel campaigns across Meta, Google (Search, PMax, YouTube), and increasingly LinkedIn — creative, media buying, tracking and reporting.' },
  { q: 'Do you provide podcast production?', a: 'Absolutely. We handle end-to-end podcast production, including concept development, scripting, cinematic multi-camera shoots, editing, distribution and clip repurposing for social.' },
  { q: 'How do you charge?', a: 'We offer three engagement models — project-based (branding, websites, one-off campaigns), monthly retainers (ongoing marketing) and performance-linked (for e-commerce & lead gen). We\'ll recommend the right fit on our discovery call.' },
  { q: 'Do you work with early-stage startups?', a: 'Yes. We work with founders from pre-launch to Series B. We\'ll be honest about what makes sense at your stage — sometimes that means starting small and scaling deliberately.' },
];

export const FOUNDER_IMG = 'https://customer-assets.emergentagent.com/job_brand-storytelling-8/artifacts/66vykity_DSC00117.webp';
